import { render, staticRenderFns } from "./PlanPrices.vue?vue&type=template&id=fa60727a&scoped=true&lang=html&"
import script from "./PlanPrices.vue?vue&type=script&lang=js&"
export * from "./PlanPrices.vue?vue&type=script&lang=js&"
import style0 from "./PlanPrices.vue?vue&type=style&index=0&id=fa60727a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa60727a",
  null
  
)

export default component.exports